export class String {
  // String.format("{0} comes before {1}", "a", "b")
  static format(stringToFormat, ...tokens) {
    return stringToFormat.replace(/{(\d+)}/g, function (match, number) {
      return typeof tokens[number] !== 'undefined' ? tokens[number] : match;
    });
  }
}
